import React from 'react';

export const Cancel = () => (
    <svg width="16" height="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 4.41 11.59 3 8 6.59 4.42 3.02 3.01 4.43 6.58 8 3 11.59 4.41 13 8 9.42 11.58 13l1.41-1.42L9.41 8 13 4.41Z" />
    </svg>
);
